import { render, staticRenderFns } from "./MySidebar.vue?vue&type=template&id=4622a3bd&"
import script from "./MySidebar.vue?vue&type=script&lang=js&"
export * from "./MySidebar.vue?vue&type=script&lang=js&"
import style0 from "./MySidebar.vue?vue&type=style&index=0&id=4622a3bd&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports